







import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

@Component({})
export default class AnonymousEmptyLayout extends Vue {

}
